import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "form","password","passwordToggleHide","passwordToggleShow" ];
  static classes = ["hide", "errorm"];
  static values = {validateurl: String};

  connect() {
    //(this.formTarget).addEventListener('submit',(e)=>{
    //  e.preventDefault();
    //})
  }

  password_toggle(){
    //if password hide
    if(this.passwordToggleShowTarget.classList.contains(this.hideClass)){
      this.passwordTarget.type = "text";
    }else {
      this.passwordTarget.type = "password";
    }
    this.passwordToggleShowTarget.classList.toggle(this.hideClass);
    this.passwordToggleHideTarget.classList.toggle(this.hideClass);
  }

  validate(event){
    const el = event.currentTarget;
    const pa = el.parentElement;
    const params = event.params;
    let errorM = pa.querySelector("."+this.errormClass);
    if(errorM == undefined){
      errorM = pa.parentElement.querySelector("."+this.errormClass);
    }
    const formData = new FormData(this.formTarget);
    formData.append("type",params.column);
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        errorM.innerHTML = response;
    }
    });
  }

}
